export default defineNuxtRouteMiddleware((to) => {
  if (to.matched.length && !useAppAbility().can('read', to.name)) {
    return abortNavigation({
      statusCode: 403,
      message: 'Nicht berechtigt',
    })
  }
})
